import React, { ReactNode } from 'react';

interface IAccordionGroup {
    // attributes
    buttonSrOnlyPrefix?: string; //Prefix à ajouter aux boutons pour les lecteurs d'écrans
    dark?: boolean;
    children: ReactNode;
    // extra nous
    className?: string;
}

export const AccordionGroup: React.FC<IAccordionGroup> = ({
    // attributes
    dark,
    buttonSrOnlyPrefix,
    children,
    // extra nous
    className
}) => (
    // @ts-ignore
    <dsd-accordion-group
        dark={dark}
        button-sr-only-suffix={buttonSrOnlyPrefix}
        className={className}
    >
        {children}
        {/* @ts-ignore */}
    </dsd-accordion-group>
);
